import React from "react";
import "./Companies.css";
const Companies = () => {
  return (
    <section className="c-wrapper">
      <div className="paddings innerWidth flexCenter c-container">
        <img src="./tower.png" alt="logo" />
        <img src="./prologis.png" alt="logo" />
        <img src="./equinix.png" alt="logo" />
        <img src="./realty.png" alt="logo" />
      </div>
    </section>
  );
};

export default Companies;
